import React, {useContext, useEffect} from 'react'

import {UnmountContext} from '../../context/UnmountContext'
import {PlayerStatsContext} from '../../context/PlayerStatsContext'
import useAuthentication from '../../hooks/useAuthentication'

import PaperPanel from '../../components/PaperPanel'

function PuzzlePopUp({children, closePuzzlePanel, location, pageUnmount, updatePageUnmount}) {
    const {finalPuzzle} = children.props
    const {unmount, updateUnmount} = useContext(UnmountContext)
    const {setGameSaved} = useContext(PlayerStatsContext)
    const {saveGame} = useAuthentication()
    
    async function saveAndReturn() {
        updatePageUnmount({name: 'waiting', state: true})
        try{
            const saved = await saveGame(location)
            setGameSaved(saved)
            updatePageUnmount({name: 'safe', state: saved})
        }catch(err){
            console.error(err)
        }
    }
        
    useEffect(() => {
        unmount.waiting && unmount.safe && closePuzzlePanel()
    }, [unmount, closePuzzlePanel])
        
    return (
        <PaperPanel extraClasses="puzzlePopUp">
            {!finalPuzzle &&
                <button
                    className="infoPopUp_close"
                    onClick={() => updateUnmount({name: 'waiting', state: true})}
                >
                    {unmount.waiting ? '...' : 'X'}
                </button>
            }
            {children}
            {finalPuzzle && 
                <button 
                    className='finalPuzzleBtn' 
                    onClick={saveAndReturn}
                >
                    {pageUnmount.waiting ? 'Saving Game' : 'Save & Continue'}
                </button>
            }
        </PaperPanel>
    )
}

export default PuzzlePopUp